import React, { ComponentProps, MouseEventHandler } from "react";
import IconButton from "components/icon-button";

type Props = {
  Icon: React.ElementType;
  color?: string;
  onClick: MouseEventHandler;
} & Omit<ComponentProps<typeof IconButton>, "variant" | "onClick">;

const IntervalActionButton = ({ Icon, color, ...props }: Props) => (
  <IconButton {...props}>
    <Icon {...(color && { color })} size="20px" />
  </IconButton>
);

export default IntervalActionButton;
